import type { SiteId } from "@/types/common/ids";

export const TransferSignatureQueryKeys = {
  all: ["transfer-signature"] as const,
  subscriberDetails: (siteId: SiteId) => [...TransferSignatureQueryKeys.all, "subscriber-details", siteId] as const,
  transferSignature: (siteId: SiteId) => [...TransferSignatureQueryKeys.all, "transfer-signature", siteId] as const,
};
